export const SERVICE_PROFILE_PERMISSIONS = {
  READ: 'IMPACTO-SERVICE-SERVICE-READ',
  UPDATE: 'IMPACTO-SERVICE-SERVICE-UPDATE',
  PUBLISH: 'IMPACTO-SERVICE-SERVICE-PUBLISH',
  UNPUBLISH: 'IMPACTO-SERVICE-SERVICE-UNPUBLISH',
  DELETE: 'IMPACTO-SERVICE-SERVICE-DELETE',
  READ_PENDING_FORWARDS: 'IMPACTO-SERVICE-SERVICE-READ_PENDING_FORWARD',
  CREATE_PENDING_FORWARD: 'IMPACTO-SERVICE-SERVICE-CREATE_PENDING_FORWARD',
  UPDATE_PENDING_FORWARD: 'IMPACTO-SERVICE-SERVICE-DELETE_PENDING_FORWARD',
  DELETE_PENDING_FORWARD: 'IMPACTO-SERVICE-SERVICE-DELETE_PENDING_FORWARD',
  READ_INITIAL_FORWARDINGS: 'IMPACTO-SERVICE-SERVICE-READ_INITIAL_FORWARDING',
  CREATE_INITIAL_FORWARDING: 'IMPACTO-SERVICE-SERVICE-CREATE_INITIAL_FORWARDING',
  UPDATE_INITIAL_FORWARDING: 'IMPACTO-SERVICE-SERVICE-DELETE_INITIAL_FORWARDING',
  DELETE_INITIAL_FORWARDING: 'IMPACTO-SERVICE-SERVICE-DELETE_INITIAL_FORWARDING',
  PUBLISH_INITIAL_FORWARDING: 'IMPACTO-SERVICE-SERVICE-DELETE_INITIAL_FORWARDING',
  UNPUBLISH_INITIAL_FORWARDING: 'IMPACTO-SERVICE-SERVICE-DELETE_INITIAL_FORWARDING',
  READ_SERVICE_LETTERS: 'IMPACTO-SERVICE-SERVICE-READ_SERVICE_LETTER',
  BIND_SERVICE_LETTER: 'IMPACTO-SERVICE-SERVICE-CREATE_SERVICE_LETTER',
  UNBIND_SERVICE_LETTER: 'IMPACTO-SERVICE-SERVICE-DELETE_SERVICE_LETTER',
  READ_PLACES: 'IMPACTO-SERVICE-SERVICE-READ_SERVICE_PLACE',
  BIND_PLACE: 'IMPACTO-SERVICE-SERVICE-CREATE_SERVICE_PLACE',
  UNBIND_PLACE: 'IMPACTO-SERVICE-SERVICE-DELETE_SERVICE_PLACE',
  READ_PUBLIC_AGENT: 'IMPACTO-SERVICE-SERVICE-READ_SERVICE_PUBLIC_AGENT',
  BIND_PUBLIC_AGENT: 'IMPACTO-SERVICE-SERVICE-CREATE_SERVICE_PUBLIC_AGENT',
  UNBIND_PUBLIC_AGENT: 'IMPACTO-SERVICE-SERVICE-DELETE_SERVICE_PUBLIC_AGENT',
  READ_TARGET_AUDIENCES: 'IMPACTO-SERVICE-SERVICE-READ_SERVICE_TARGET_AUDIENCE',
  BIND_TARGET_AUDIENCE: 'IMPACTO-SERVICE-SERVICE-CREATE_SERVICE_TARGET_AUDIENCE',
  UNBIND_TARGET_AUDIENCE: 'IMPACTO-SERVICE-SERVICE-DELETE_SERVICE_TARGET_AUDIENCE',
  READ_ACTIVITIES_TYPES: 'IMPACTO-SERVICE-SERVICE-READ_SERVICE_ACTIVITY_TYPE',
  BIND_ACTIVITY_TYPE: 'IMPACTO-SERVICE-SERVICE-CREATE_SERVICE_ACTIVITY_TYPE',
  UNBIND_ACTIVITY_TYPE: 'IMPACTO-SERVICE-SERVICE-DELETE_SERVICE_ACTIVITY_TYPE',
  READ_CUSTOM_FORM: 'IMPACTO-SERVICE-SERVICE-READ',
  CREATE_CUSTOM_FORM: 'IMPACTO-SERVICE-SERVICE-READ',
  UPDATE_CUSTOM_FORM: 'IMPACTO-SERVICE-SERVICE-READ',
  UPDATE_CUSTOM_FORM_VISIBILITY: 'IMPACTO-SERVICE-SERVICE-READ',
  DELETE_CUSTOM_FORM: 'IMPACTO-SERVICE-SERVICE-READ',
  CREATE_CUSTOM_FORM_QUESTION: 'IMPACTO-SERVICE-SERVICE-READ',
  UPDATE_CUSTOM_FORM_QUESTION: 'IMPACTO-SERVICE-SERVICE-READ',
  DELETE_CUSTOM_FORM_QUESTION: 'IMPACTO-SERVICE-SERVICE-READ',
}
